import React from "react";
import { connect } from "react-redux";

import { Button } from "../../../atoms/Buttons/Base";
import { Text } from "../../../atoms/Text/Text";
import { User } from "../../../models/User";
import { FriendUserInfo } from "../../../models/FriendModel";
import { FriendActionState } from "../../../models/Enums";
import FriendApiService from "../../../services/Friend/FriendApiService";
import { setFriendActionState } from "../../../store/reducers";
import classNames from "classnames";
import styles from "./SendInvitePopup.css";

type RemoveFriendProps = {
  user: User;
  friendToRemove?: FriendUserInfo;
  onClose: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onLoadContent: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  dispatch?: any;
};

class RemoveFriendDumb extends React.PureComponent<RemoveFriendProps> {
  static displayName = "RemoveFriend";

  ClickRemoveFriend = () => {
    if (this.props.user && this.props.friendToRemove) {
      FriendApiService.DeleteFriend(this.props.friendToRemove.id)
        .then(() => {
          this.props.dispatch(
            setFriendActionState(FriendActionState.RemoveFriend)
          );
          if (this.props.onClose) {
            this.props.onClose(null);
          }
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });
    }
  };

  componentDidMount() {
    this.props.onLoadContent(null);
  }

  render() {
    return (
      <React.Fragment>
        <Text
          className={styles.coverHeaderInfo}
          bold={true}
          size="h3"
          align="center"
        >
          Are you sure you want to remove this user?
        </Text>

        <Text
          bold={true}
          size="md"
          className={classNames(styles.userNameInvitor, styles.coverTitleInfo)}
        >
          {" "}
          {this.props.friendToRemove.name}{" "}
        </Text>

        <div>
          <Button
            className={classNames(styles.buttonYesNo, styles.buttonFriend)}
            onClick={this.ClickRemoveFriend}
          >
            <Text bold={true} size="sm" style={{ padding: "5px" }}>
              Yes
            </Text>
          </Button>

          <Button
            className={classNames(styles.buttonYesNo, styles.buttonFriend)}
            onClick={this.props.onClose}
          >
            <Text bold={true} size="sm" style={{ padding: "5px" }}>
              No
            </Text>
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
export const RemoveFriend = connect()(RemoveFriendDumb);
